jQuery(document).ready(function () {
  var initialNavbarOffset = jQuery(".navbar").offset().top;

  function checkScrollAndResize() {
    var navbarHeight = jQuery(".navbar").outerHeight();
    var scrollPos = jQuery(window).scrollTop();

    console.log("Navbar height: " + navbarHeight);
    console.log("Scroll position: " + scrollPos);
    console.log("Navbar offset: " + initialNavbarOffset);

    if (scrollPos >= initialNavbarOffset) {
      jQuery(".navbar").addClass("fixed-topp");
      jQuery("body").css("padding-top", navbarHeight + "px");
    } else {
      jQuery(".navbar").removeClass("fixed-topp");
      jQuery("body").css("padding-top", "0px");
    }
  }

  // Call on scroll
  jQuery(window).on("scroll", checkScrollAndResize);

  // Call on resize
  jQuery(window).on("resize", checkScrollAndResize);

  jQuery(".offcanvas .anchor").on("click", function () {
    jQuery(".offcanvas").removeClass("show");
    jQuery(".offcanvas-backdrop").removeClass("show");
  });
});

var link = jQuery(
  "a._brlbs-btn-cookie-preference.borlabs-cookie-preference"
).detach(); // detach the link from its current position
link.wrap("<li class='cookies'></li>"); // wrap it with li
link.parent().appendTo("#menu-footer"); // append it to ul

let swiperResentProjects = new Swiper(".home .swiperCases", {
  speed: 100,
  loop: true,
  autoplay: {
    delay: 10000,
  },
  spaceBetween: 0,
  draggable: false,
  slidesPerView: 1,
  slidesPerGroup: 1,
  roundLengths: true,
  // effect: "fade",
  pagination: {
    el: ".swiper-pagination-home-one",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  keyboard: {
    enabled: true,
  },
});

let swiper = new Swiper(".swiperRed", {
  speed: 100,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  spaceBetween: 0,
  draggable: false,
  slidesPerView: 1,
  slidesPerGroup: 1,
  roundLengths: true,
  // effect: "fade",
  pagination: {
    el: ".swiper-pagination-red",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next-red",
    prevEl: ".swiper-button-prev-red",
  },
  keyboard: {
    enabled: false,
  },
});

let swiperCasesHero = new Swiper(".swiperCasesHero", {
  speed: 100,
  loop: false,
  autoplay: {
    delay: 5000,
  },
  spaceBetween: 0,
  draggable: false,
  slidesPerView: 1,
  slidesPerGroup: 1,
  roundLengths: true,
  // effect: "fade",
  pagination: {
    el: ".swiper-pagination-caseshero",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next-caseshero",
    prevEl: ".swiper-button-prev-caseshero",
  },
  keyboard: {
    enabled: false,
  },
});

let swiperContact;

function initSwiper() {
  swiperContact = new Swiper(".contactSlider", {
    speed: 100,
    loop: false,
    spaceBetween: 0,
    draggable: false,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    roundLengths: true,
    navigation: {
      nextEl: ".swiper-button-next-contact",
      prevEl: ".swiper-button-prev-contact",
    },
    keyboard: {
      enabled: false,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
    },
  });
}

function swiperExists() {
  return document.querySelector(".contactSlider") !== null;
}

function destroySwiper() {
  if (swiperContact) {
    swiperContact.destroy(true, true);
    swiperContact = null;
  }
}

function handleResize() {
  // Only proceed if the Swiper container exists on the page
  if (!swiperExists()) return;

  if (window.innerWidth > 640) {
    if (!swiperContact) initSwiper(); // Only initialize swiper if it's not already initialized
  } else {
    destroySwiper();
  }
}

window.addEventListener("resize", handleResize);
handleResize();
